import { NoSymbolIcon } from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import { selectCurrentUserInfo } from "../../store/feautures/AuthSlice";
import { SuperAdminVisore } from "../../utils/genericList/ListRoleRoutes";
import ManageStateAccount from "../accounts/ManageStateAccount";
import DialogComponent from "../main/DIalogComponent";


export default function DisableAccount({ row }: any) {

    const { role } = useSelector(selectCurrentUserInfo);

    return (
        SuperAdminVisore.includes(role)
            ? ((role === 'Admin' || role === 'AdvancedAdmin') && row?.ruolo !== 'SuperAdmin') || role === 'SuperAdmin' || role === 'Supervisore' 
            ?   <DialogComponent
                    icon={<NoSymbolIcon className="w-6 h-6" />}
                    label={'Disattiva utente'}
                    content={
                        <ManageStateAccount row={row} typeAction={'disable'} />
                    }
                />
                : <></>
            : <></>
    )
}